import React from 'react'

interface DateTimeDTProps {
  size?: number | string;
  color?: string;
  className?: string;
  onClick?: () => void;
}

const DateTimeDT: React.FC<DateTimeDTProps> = ({
  size = 20,
  color = '#003366',
  className,
  onClick,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    <path d="M6.66699 1.66797V4.16797" stroke={color} strokeWidth="1.3" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M13.333 1.66797V4.16797" stroke={color} strokeWidth="1.3" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M2.91699 7.57422H17.0837" stroke={color} strokeWidth="1.3" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M15.0003 19.1667C16.8413 19.1667 18.3337 17.6743 18.3337 15.8333C18.3337 13.9924 16.8413 12.5 15.0003 12.5C13.1594 12.5 11.667 13.9924 11.667 15.8333C11.667 17.6743 13.1594 19.1667 15.0003 19.1667Z" stroke={color} strokeWidth="1.3" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M16.2421 15.875H13.7588" stroke={color} strokeWidth="1.3" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M15 14.6582V17.1499" stroke={color} strokeWidth="1.3" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M17.5 7.08464V13.6346C16.8917 12.943 16 12.5013 15 12.5013C13.1583 12.5013 11.6667 13.993 11.6667 15.8346C11.6667 16.4596 11.8417 17.0513 12.15 17.5513C12.325 17.8513 12.55 18.118 12.8083 18.3346H6.66667C3.75 18.3346 2.5 16.668 2.5 14.168V7.08464C2.5 4.58464 3.75 2.91797 6.66667 2.91797H13.3333C16.25 2.91797 17.5 4.58464 17.5 7.08464Z" stroke={color} strokeWidth="1.3" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9.99607 11.4167H10.0036" stroke={color} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6.91209 11.4167H6.91957" stroke={color} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6.91209 13.9167H6.91957" stroke={color} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export default DateTimeDT